const handleLongText = (text: string = '', char_limit: number) => { 
    if (typeof text === 'string' && text.split('').length > char_limit) {
        let formatText = text.split('').slice(0, char_limit - 3)
        const result = formatText.join('')
        return result + '...'
    }
    return text
}

export default handleLongText